import { useContext } from "react";
import { ResumeContext } from "../context/resume/resume-context";


export default function useResumeProperties() {
    const { resumeData } = useContext( ResumeContext );
    return extractResumeProperties(resumeData);
}

export function extractResumeProperties(resumeData) {
    return {
        documentLanguage: resumeData?.properties?.documentLanguage || 'fr',
        isAlcyone: resumeData?.properties?.isAlcyone || true,
        isAnonymous: resumeData?.properties?.isAnonymous || false,
        isCssf: resumeData?.properties?.isCssf || false,
        isEuropass: resumeData?.properties?.isEuropass || false,
        isExperienceHidden: resumeData?.properties?.isExperienceHidden || false,
        jobTitle: resumeData?.properties?.jobTitle || '',
        keywords: resumeData?.properties?.keywords || [],
        logoLabel: resumeData?.properties?.logoLabel || "Alcyone",
        logoSrc: resumeData?.properties?.logoSrc || "/logo-cv.png",
    };
}
